import { Typography, withStyles } from '@material-ui/core';

export const ModelParagraphSubtitle = withStyles({
  root: {
    textAlign: 'left',
    fontWeight: 500,
    letterSpacing: '0',
    color: '#292F36',
    fontSize: '1rem',
  },
})(Typography);
